import { ca } from "date-fns/locale";
import mapPictures from "../../../../shared/image-mapper";
import { DELETE_MULTIPLE_SHOTS, SAVE_SHOTS_ORDER, UPLOAD_SHOTS } from "../overview/ducks/actions";
import { CLEAR_SHOT_REDIRECT, COPY_SHOT } from "./actions";

const defaultState = {
  shots: [],
  shot: {},
  loading: true,
  readOnly: false
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case "FETCH_SHOTS_PENDING": {
      return {
        ...state,
        loading: true
      };
    }

    case "FETCH_SHOTS_FULFILLED": {
      return {
        ...state,
        shots: action.payload.data.shots,
        readOnly: action.payload.data.readOnly,
        loading: false,
        errors: null
      };
    }

    case SAVE_SHOTS_ORDER + "_FULFILLED": {
      return {
        ...state,
        shots: action.payload.data.shots
      };
    }

    case COPY_SHOT + "_PENDING": {
      return {
        ...state,
        loading: true
      }
    }

    case COPY_SHOT + "_FULFILLED": {
      const shot = action.payload.data.shot;
      const shots = [...state.shots, shot];

      return {
        ...state,
        shots,
        redirect: { to: "shot", id: shot.id },
        loading: false
      }
    }

    case COPY_SHOT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      }
    }

    case "FETCH_SINGLE_SHOT_PENDING": {
      return {
        ...state,
        shot: null,
        loadingShot: true
      };
    }

    case "FETCH_SINGLE_SHOT_FULFILLED": {
      let shot = action.payload.data;

      mapPictures(shot);

      return {
        ...state,
        shot: action.payload.data,
        loadingShot: false,
        errors: null
      };
    }

    case "UPDATE_SINGLE_SHOT_PENDING": {
      return {
        ...state,
        shot: action.payload,
        loadingShot: true,
        errors: null
      };
    }

    case "UPDATE_SINGLE_SHOT_FULFILLED": {
      const shot = { ...action.meta.shot, ...action.payload.data.shot };
      const shots: any = state.shots.map((c: any, index: number) => {
        if (c.id === shot.id) {
          return { ...c, ...shot };
        } else {
          return c;
        }
      });

      sortShots(shots);

      return {
        ...state,
        shot,
        shots,
        loadingShot: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case "UPDATE_SINGLE_SHOT_REJECTED": {
      return {
        ...state,
        shot: action.meta.shot,
        errors: action.payload.response.data.errors,
        loadingShot: false
      };
    }

    case "ADD_SINGLE_SHOT_PENDING": {
      return {
        ...state,
        shot: action.payload,
        errors: null,
        loadingShot: true
      };
    }

    case "INITIALIZE_ADD_SHOT_FORM": {
      let nextNumber = 1;
      if (state.shots && state.shots.length > 0) {
        const maxNumber = Math.max.apply(
          null,
          state.shots.map((shot: any) => {
            return shot.number;
          })
        );
        nextNumber = maxNumber + 1;
      }

      return {
        ...state,
        shot: { number: nextNumber },
        errors: null,
        loadingShot: false
      };
    }

    case "ADD_SINGLE_SHOT_FULFILLED": {
      const shot: any = action.payload.data.shot;

      let shots = [shot, ...state.shots];

      sortShots(shots);

      return {
        ...state,
        shot,
        shots,
        loadingShot: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case "ADD_SINGLE_SHOT_REJECTED": {
      return {
        ...state,
        shot: action.meta.shot,
        errors: action.payload.response.data.errors,
        loadingShot: false
      };
    }

    case UPLOAD_SHOTS + "_FULFILLED": {
      const newShots = action.payload.data.sceneShots;
      const existingShots: any[] = [...state.shots];

      // Merge new shots with existing shots, avoiding duplicates
      newShots.forEach(newShot => {
        const existingIndex = existingShots.findIndex((existingShot: any) => existingShot.number === newShot.number);
        if (existingIndex !== -1) {
          // Update existing shot
          existingShots[existingIndex] = newShot;
        } else {
          // Add new shot
          existingShots.push(newShot);
        }
      });

      sortShots(existingShots);

      return {
        ...state,
        shots: existingShots,
        loading: false
      };
    }

    case "DELETE_SINGLE_SHOT_PENDING": {
      return {
        ...state,
        shot: action.payload,
        loadingShot: true,
        errors: null
      };
    }

    case "DELETE_SINGLE_SHOT_FULFILLED": {
      const shot = action.meta.shot;
      const updatedShots = action.payload.data.shots;
      const newShots = Array.from(state.shots);
      const shots: any = newShots.filter((c: any, index: number) => {
        return c.id !== shot.id;
      });

      shots.forEach(shot => {
        const updatedShot = updatedShots.find(s => s.id === shot.id);
        if (updatedShot) {
          shot.number = updatedShot.number;
        }
      });



      return {
        ...state,
        shot: null,
        shots,
        loadingShot: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case "DELETE_SINGLE_SHOT_REJECTED": {
      return {
        ...state,
        shot: action.meta.shot,
        errors: action.payload.response.data.errors,
        loadingShot: false
      };
    }

    case DELETE_MULTIPLE_SHOTS + "_FULFILLED": {
      const updatedData = action.payload.data.shots;
      const deletedIds = action.meta.shotIds;

      // Filter out deleted shots and merge updated numbers
      const mergedShots = state.shots
        .filter((shot: any) => !deletedIds.includes(shot.id))
        .map((shot: any) => {
          const updated = updatedData.find((u: any) => u.id === shot.id);
          return updated ? { ...shot, number: updated.number } : shot;
        });

      return {
        ...state,
        shots: mergedShots
      };
    }

    case "FETCH_FRAMES_PER_SECOND_FULFILLED": {
      const shot = { ...state.shot, frameRate: action.payload.data.frameRate };
      return {
        ...state,
        shot: shot
      };
    }

    case CLEAR_SHOT_REDIRECT: {
      return {
        ...state,
        shot: null,
        redirect: null
      };
    }

    case "UPLOAD_IMAGES_PENDING": {
      return {
        ...state,
        loadingShot: true
      };
    }

    case "UPLOAD_IMAGES_REJECTED": {
      return {
        ...state,
        loadingShot: false,
        errors: action.payload.response.data.errors,
      };
    }

    case "UPLOAD_IMAGES_FULFILLED": {
      return {
        ...state,
        loadingShot: false
      };
    }

    default:
      return state;
  }
};

function sortShots(shots) {
  shots.sort((a, b) => {
    return a.number - b.number;
  });
}

export default reducer;
